module.exports = __webpack_public_path__ + "img/sort-icon.cfa81c08.svg";